export const APP_ROOT = 'root';

export const KRATOS_URL = import.meta.env.VITE_KRATOS_URL;
